import { ReactElement } from "react";
import BasicLayout from "../layouts/BasicLayout";
import { Outlet } from "react-router-dom";
import Employees from "../employees/views/Employees";

export const employeeRoutes = [
  { id: 1, path: "", component: <Employees /> },
];

const EmployeeListRoute = (props: any): ReactElement => {
  const data = props.loginData;
  const permissions = props.permissions;

  return (
    <BasicLayout userData={data} permissions={permissions} sidebars={props.sidebarsData}>
      <Outlet />
    </BasicLayout>
  );
};

export default EmployeeListRoute;
